import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const QuickEditSelect = props => {
  const {
    quickEdit,
    formControlProps,
    inputProps
  } = props;

  let {
    inputOptions
  } = props;

  // if default value is an object then set it to the id field
  if (typeof inputProps.defaultValue === 'object') {
    inputProps.defaultValue = inputProps.defaultValue.id;
  }

  // default to 1st option, disabling
  //inputProps.defaultValue ||= colDef.inputOptions[0].value;

  inputProps.SelectProps.open = quickEdit.isSelectOpen(inputProps.id);
  inputProps.SelectProps.onFocus = () => quickEdit.openSelect(inputProps.id);
  inputProps.SelectProps.onFocusOut = quickEdit.closeSelect;

  inputProps.SelectProps.MenuProps = {
    onClose: quickEdit.closeSelect
  }

  // include blank option
  let noneLabel = '- None -';
  let noneOption = { value: null, label: noneLabel, labelStr: noneLabel }
  inputOptions ||= [];
  inputOptions.unshift(noneOption);

  //if (colDef.inputOptions) {
  //  inputOptions = inputOptions.concat(colDef.inputOptions);
  //}

  return (
    <div>
      <FormControl {...formControlProps}>
        <TextField {...inputProps} select>
          {inputOptions.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </div>
  );
}

export default QuickEditSelect;
